import { useContext } from 'react';
import { createContext } from 'react';

import { NewsletterInputEmailProps } from '../@types/NewsletterInputEmailProps';

export const NewsletterInputEmailContext = createContext<NewsletterInputEmailProps>({} as NewsletterInputEmailProps);

NewsletterInputEmailContext.displayName = 'NewsletterInputEmail';

const NewsletterInputEmailProvider = (props: NewsletterInputEmailProps) => (
	<NewsletterInputEmailContext.Provider value={props}>{props.children}</NewsletterInputEmailContext.Provider>
);

export const useNewsletterInputEmail = () => {
	const context = useContext(NewsletterInputEmailContext);

	return context;
};

export default NewsletterInputEmailProvider;
